export const DICE_COLOR_PRESETS = {
	default: {
		key: 'default',
		label: 'Default',
		diceColor: '#202020',
		labelColor: '#aaaaaa',
		badgeBackground: '#111827',
		badgeColor: '#f9fafb',
		iconColor: '#111827',
	},
	white: {
		key: 'white',
		label: 'White',
		diceColor: '#f3f4f6',
		labelColor: '#111827',
		badgeBackground: '#f3f4f6',
		badgeColor: '#111827',
		iconColor: '#d1d5db',
	},
	red: {
		key: 'red',
		label: 'Red',
		diceColor: '#b91c1c',
		labelColor: '#ffffff',
		badgeBackground: '#dc2626',
		badgeColor: '#ffffff',
		iconColor: '#ef4444',
	},
	blue: {
		key: 'blue',
		label: 'Blue',
		diceColor: '#1d4ed8',
		labelColor: '#ffffff',
		badgeBackground: '#2563eb',
		badgeColor: '#ffffff',
		iconColor: '#3b82f6',
	},
	green: {
		key: 'green',
		label: 'Green',
		diceColor: '#15803d',
		labelColor: '#ffffff',
		badgeBackground: '#16a34a',
		badgeColor: '#ffffff',
		iconColor: '#22c55e',
	},
	yellow: {
		key: 'yellow',
		label: 'Yellow',
		diceColor: '#facc15',
		labelColor: '#111827',
		badgeBackground: '#facc15',
		badgeColor: '#111827',
		iconColor: '#eab308',
	},
	black: {
		key: 'black',
		label: 'Black',
		diceColor: '#030712',
		labelColor: '#ffffff',
		badgeBackground: '#111827',
		badgeColor: '#ffffff',
		iconColor: '#111827',
	},
};

export const DEFAULT_DICE_COLOR = 'default';
export const DEFAULT_DICE_LABEL = 'default';

export const normalizeDiceLabel = (value = DEFAULT_DICE_LABEL) => {
	const normalized = String(value)
		.toLowerCase()
		.trim()
		.replace(/\s+/g, '_')
		.replace(/[^a-z0-9_]/g, '_')
		.replace(/_+/g, '_')
		.replace(/^_+|_+$/g, '');

	return normalized || DEFAULT_DICE_LABEL;
};

export const getDiceColorPreset = (key = DEFAULT_DICE_COLOR) =>
	DICE_COLOR_PRESETS[key] || DICE_COLOR_PRESETS[DEFAULT_DICE_COLOR];

export const isSelectedDie = (value) =>
	Boolean(value && typeof value === 'object' && typeof value.notation === 'number');

export const toSelectedDie = (value) => {
	if (isSelectedDie(value)) {
		return {
			notation: value.notation,
			color: value.color || DEFAULT_DICE_COLOR,
			label: normalizeDiceLabel(value.label),
		};
	}

	return {
		notation: Number(value),
		color: DEFAULT_DICE_COLOR,
		label: DEFAULT_DICE_LABEL,
	};
};

export const formatDiceSelection = (die) => {
	const selectedDie = toSelectedDie(die);
	return `1d${selectedDie.notation} [${selectedDie.color}:${selectedDie.label}]`;
};
